import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservaService } from 'src/app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { pdfDefaultOptions, PdfSidebarView } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-orcamentodownload',
  templateUrl: './orcamentodownload.component.html',
  styleUrls: ['./orcamentodownload.component.scss'],
  standalone: false
})
export class OrcamentodownloadComponent implements OnInit {

  constructor(
    private reservaService: ReservaService,
    public route: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal,
  ) { 
    pdfDefaultOptions.assetsFolder = window.location.hostname !== "localhost" ? 'assets/ngx-extended-pdf-assets' : "assets";
    pdfDefaultOptions.sidebarViewOnLoad = PdfSidebarView.THUMBS; // Set default sidebar view to thumbnails
  }
  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.simplificado = this.route.snapshot.params['simplificado'];
    if (this.id !== undefined && this.simplificado !== undefined) {
      setTimeout(() => { this.carregarObjeto(this.id, this.simplificado); }, 500);
    }
  }

  id: number;
  simplificado: boolean;

  orcamento = null;
  erros = null;
  carregando = true;
  pageLabel: string;
  email = '';
  errors: string[];
  success: string;
  form: UntypedFormGroup;
  loadingEnvio = false;
  mostraForm = false;


  carregarObjeto(id, simplificado) {
    this.reservaService.exibirOrcamento(id, simplificado).subscribe(
      dados => {
        // this.orcamento = URL.createObjectURL(dados);
        this.orcamento = dados;
        this.carregando = false;
      },
      erros => {
        this.erros = erros;
      }
    )
  }


  pageRendered(e: CustomEvent) {
    this.carregando = false;
  }

  onError(event) {
    console.log("ERRO AO CARREGAR O PDF:", event);
  }

  imprimir() {
    window.open(this.orcamento);
  }
  fecharModalEmail() {
    this.modalService.dismissAll();
  }

  abrirModalEmail(modal) {
    this.mostraForm = true;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }

  EnviarOrcamento() {
    delete this.errors;
    delete this.success;
    this.loadingEnvio = true;
    this.reservaService.enviarOrcamento(this.id, this.simplificado, this.email).subscribe(
      dados => {
        this.success = 'E-mail enviado!';
        this.loadingEnvio = false;
        this.modalService.dismissAll();
      }, erro => {
        console.log('Erro ao enviar !');
        console.log(erro.error.mensagem);
        if (erro.status === 400) {
          this.errors = [erro.error.mensagem];
        } else {
          this.errors = ['Houve algum erro, tente novamente'];
        }
        this.loadingEnvio = false;
      });
  }
}
